<template>
  <div class="table-wrapper small">
    <table>
      <thead>
      <tr>
        <th style=" padding-left: 0" >
          {{ headings.col1.name }}
        </th>
        <th>
          {{ headings.col2.name }}
        </th>
        <th data-hide>
          {{ headings.col3.name }}
        </th>
        <th style="width: 127px">
          {{ headings.col4.name || 'Åtgärder'}}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(document, docIndex) in documents" :key="docIndex">
        <td style="white-space: unset; padding-left: 0" :title="document.title"><strong>{{ document.title }}</strong></td>
        <td >
          <div v-for="(file, index) in document.files" :key="index" style="display: flex; gap:4px">
            <a :href="file.url" target="_blank"
               v-html="`${file.name}`" download
               style="text-overflow:  ellipsis; white-space: nowrap; overflow: hidden;"
               :title="file.name"/>
            <div style="position: relative; width:26px">
            <delete-file-component
              v-if="file.deleteUrl"
              class="file-delete-container"
              :document="document"
              :file="file"
              @fileDeleted="rerenderDOMElement">
            </delete-file-component>
            </div>
          </div>
        </td>
        <td data-hide>
          <div v-for="(file, index) in document.files" :key="index" class="col-document-date"
               style="text-overflow:  ellipsis; white-space: nowrap; overflow: hidden;" :title="file.updated">
            {{ file.updated }}
          </div>
        </td>
          <td style="padding-left: 0; padding-right: 0;width: 127px">
          <slot :actionItem="actionItems[docIndex]"></slot>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</template>
<script>
  import { Document } from '@/classes/case/Document'
  import DeleteFileComponent from '@/components/layout/utility/DeleteFileComponent'

  export default {
    name: 'documents-delete-table-component',
    components: {
      DeleteFileComponent
    },
    data () {
      return {
        rerenderDoc: 0
      }
    },
    props: {
      headings: {
        type: Object,
        default: () => ({
          col1: { name: 'Documents', classes: 'is-4-tablet is-3-desktop' },
          col2: { name: 'Filename', classes: 'is-4-tablet is-6-desktop' },
          col3: { name: 'Uploaded at', classes: 'is-4-tablet is-3-desktop' }
        })
      },
      documents: {
        type: Array,
        validator: (prop) => prop.every(e => e instanceof Document),
        required: true
      },
      actionItems: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      rerenderDOMElement () {
        this.rerenderDoc++
      }
    }
  }
</script>
<style lang="sass" scoped>

@import "src/assets/sass/kiwa-styles.sass"

.file-delete-container
  position: absolute
  top: -5px
  right: 0

.table-col
  color: #4D4D4D

  .col-header
    margin-bottom: 0.5rem

  .col-document
    position: relative
    height: 30px
    overflow: hidden
    padding-right: 1.5em

    a
      width: 100%
      display: inline-block
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap

  .col-document-date
    height: 30px

.table-wrapper
  overflow-x: auto
  border-bottom: 1px solid $kiwa-primary
  width: 100%
  color: #4D4D4D
  @media screen and (max-width: 1280px)
    td[data-hide],th[data-hide]
      display: none
  a
    width: 100%
    display: inline-block
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap

  .expanded-td
    width: 100% !important
    max-width: unset

  &.small
    th,
    td
      padding: 8px 12px
      font-weight: 600
      text-align: left
      color: #4D4D4D
    .n-th-container
      justify-content: start

      &.center
        justify-content: center

    thead
      tr
        background-color: white

      th
        color: #4D4D4D
        font-size: 14px
        text-transform: uppercase

    background-color: #6E8A9CFF

    &.fixed-height
      min-height: calc(42.6px * 10 + 45px)

    &.fixed-height
      min-height: calc(28px * 10 + 26.5px)

  table
    border-spacing: 0
    width: 100%
    table-layout: fixed

    th,
    td
      max-width: 250px
      padding: 16px 24px
      text-align: center
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis

    tbody
      tr
        background-color: White

      td
        color: #4D4D4D

    thead
      tr
        background-color: #335265

      th
        color: white
        font-size: 18px
        text-transform: uppercase

</style>
